import { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';

import { QueryDraggableTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { Dialog, Txt } from '@app/components/common';
import { Level } from '@app/api/models/structure';
import { usePermissions } from '@app/hooks/use-permissions';
import { ROLES } from '@app/navigation/types';
import Error404 from '@app/pages/errors/404';

import { useColumns } from './columns';
import { LevelForm } from './form';
import { DragSubmit } from './drag-submit';

export const LevelsTable = () => {
  const api = useApi();
  const [fetchData] = useFetchData<Level>({ method: api.structure.getLevels });
  const [selectedLevel, setSelectedLevel] = useState<Level>();
  const [modal, setModal] = useState<'add' | 'edit' | 'drag' | null>(null);
  const [dragValues, setDragValues] = useState<{ updatedArray: Level[], oldIndex: number, newIndex: number }>();

  const hasPermission = usePermissions({ roles: [ROLES.ADMIN, ROLES.CHIEF] });

  const columns = useColumns({
    onEdit: (item: Level) => {
      setSelectedLevel(item);
      setModal('edit');
    }
  });

  const onFormSubmit = async () => {
    setModal(null);
  };

  const onDragEnd = async (updatedArray, oldIndex, newIndex) => {
    setDragValues({ updatedArray, oldIndex, newIndex });
    setModal('drag');
  };

  if (!hasPermission) {return <Error404/>;}

  return (
    <>
      <QueryDraggableTable
        title="Уровни организации"
        columns={columns}
        fetchData={fetchData}
        onDragEnd={onDragEnd}
        onCreateClick={() => setModal('add')}
        initialSort={{ name: 'value', direction: 'desc' }}
        
      >
        <Dialog open={modal === 'edit' || modal === 'add'}
          onClose={() => setModal(undefined)}
          title={modal === 'edit' ? 'Редактирование' : 'Добавление'}
          width={800}
        >
          <LevelForm
            initial={modal === 'edit' ? selectedLevel : undefined}
            onSubmit={onFormSubmit}
            onCancel={() => setModal(undefined)}
          />
        </Dialog>
        <DragSubmit
          open={modal === 'drag'}
          onClose={() => setModal(undefined)}
          dragValues={dragValues}
        />
      </QueryDraggableTable>
    </>
  );
};